module.exports = __webpack_public_path__ + "06b537ba2e2a0aa35eacb2cd62a0fb2c.pdf";